export default __webpack_public_path__ + "static/media/Minicard_6d.a49a9163.svg";